import { render, staticRenderFns } from "./ReviewInfo.vue?vue&type=template&id=6d0507fe"
import script from "./ReviewInfo.vue?vue&type=script&lang=ts"
export * from "./ReviewInfo.vue?vue&type=script&lang=ts"
import style0 from "./ReviewInfo.vue?vue&type=style&index=0&id=6d0507fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports